import { render, staticRenderFns } from "./FooterTreeColumnMobile.vue?vue&type=template&id=39c659c0&scoped=true"
import script from "./FooterTreeColumnMobile.vue?vue&type=script&lang=js"
export * from "./FooterTreeColumnMobile.vue?vue&type=script&lang=js"
import style0 from "./FooterTreeColumnMobile.vue?vue&type=style&index=0&id=39c659c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c659c0",
  null
  
)

export default component.exports